module.exports = __webpack_public_path__ + "static/media/product5.ecb23226.jpg";